/* --------------------------------------------------------------------------------------
   searchPopup.component.js

   Copyright © 2019 Xerox Corporation. All Rights Reserved.
   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const searchPopupComponent = {
  template: require('./searchPopup.html'),
  bindings: {
    display: '=',
    selected: '=',
    items: '=',
    previewNode: '='
  },
  controllerAs: 'vm',
  controller: class searchPopupCtrl {
    /*@ngInject*/
    constructor(browserService, commonService, $timeout) {
      this.browserService = browserService
      this.commonService = commonService
      this.$timeout = $timeout
    }
    async $onInit() {
      this.screenSize = await this.commonService.getScreenSize()
      this.searchTerms = ""
      this.selected = []
      angular.element('#search-message-table-wrapper').height('1250px')
    }
    async search() {
      this.getKeyboard().accept()
      this.searchResults = this.items.filter(item => item.DisplayName.toLowerCase().includes(this.searchTerms.toLowerCase()))
      this.$timeout(angular.noop, 500).then(() => angular.element('#search-result-table').xrxtable('scroll', this.getResultsTableHeight()))
    }
    searchTermChanged() {
      this.searchTermsBackup = angular.copy(this.searchTerms)
      angular.element('#popup-search-button').xrxbutton({disabled: this.searchTerms.length < 3 })
    }
    searchTermCancel() {
      this.$timeout(() => this.searchTerms = this.searchTermsBackup,50)
    }
    ok() {
      this.selected = this.searchResults.filter(r => r.selected)
      this.searchResults = []
      this.getKeyboard().accept()
      this.closePopup()
    }
    cancel() {
      this.getKeyboard().accept()
      this.closePopup()
    }
    closePopup() {
      this.searchResults = null
      this.display = false
      this.commonService.updateView()
    }
    getKeyboard() {
      return angular.element("#search-input").getkeyboard()
    }
    getSelected() {
      if (!this.hasOwnProperty('searchResults'))
        return []
      return this.searchResults.filter(item => item.selected)
    }
    getResultsTableHeight() {
      const maxHeight = this.screenSize == 7? 313 : 384
      const rowHeight = this.screenSize == 7? 73 : 68
      const totalHeight = this.searchResults.length * rowHeight
      return Math.min(maxHeight, totalHeight)
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/browser/components/searchPopup.component.js